import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Layout } from 'modules/layout/containers';
import { RouteManager } from 'modules/router/containers';
import { PersistGate } from 'redux-persist/integration/react';
import { WalletConnectContext } from 'services';
import store from 'store/configureStore';
import { theme } from 'theme';

import '@splidejs/react-splide/dist/css/themes/splide-default.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/index.scss';

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <Provider store={store.store}>
    <PersistGate loading={null} persistor={store.persistor}>
      <Router>
        <Suspense fallback={<div>Loading ...</div>}>
          <WalletConnectContext>
            <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <CssBaseline />
                <Layout>
                  <RouteManager />
                </Layout>
              </LocalizationProvider>
            </ThemeProvider>
          </WalletConnectContext>
        </Suspense>
      </Router>
    </PersistGate>
  </Provider>,
);
